// Importing constants
import closeImgIcon from 'static/images/close.svg';

// Importing Components
import { Button } from 'components/form-elements';
import { Modal, ConditionalComponent } from 'components';
import FindTransactionForm from './FindTransactionForm';
import RaiseChargebackForm from './RaiseChargebackForm';

// Importing Libraries
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { capitalizeFirstLetter } from 'utils/helperMethods';

const RaiseChargeBackComponent = ({
    isTransactionPage,
    transactionPageData,
    onRaiseSuccess,
    raiseChargeBackRequest,
}) => {
    const initialDataTransactionPage = {
        merchantId: transactionPageData?.merchantId,
        date: transactionPageData?.transactionDateAndTime,
        orderId: transactionPageData?.orderId,
        amount: transactionPageData?.amount,
        dueDate: moment()
            .add(4, 'days')
            .set({ hour: 18, minute: 30, second: 0 })
            .format('YYYY-MM-DD HH:mm:ss'),
        cbStatus: 'NEW',
        rrnNumber: transactionPageData?.rrnArn,
        remarks: 'remarks',
        cbLevel: 'L1',
        reportedDate: moment().startOf('day'),
        txnId: transactionPageData?.transactionReferenceNumber,
        merchantName: transactionPageData?.merchantName,
        paymentType: transactionPageData?.paymentMode,
        transactionSubMode: transactionPageData?.transactionSubMode,
    };

    const [currentStep, setCurrentStep] = useState(isTransactionPage ? 2 : 1);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [
        initialRaiseChargebackData,
        setInitialRaiseChargebackData,
    ] = useState(isTransactionPage ? initialDataTransactionPage : {});

    useEffect(() => {
        if (!isModalOpen && !isTransactionPage) {
            setCurrentStep(1);
        }
    }, [isModalOpen, isTransactionPage]);

    const handleRaiseChargeBackClick = () => {
        setIsModalOpen(true);
    };

    const handleValidateFormSubmit = selectedTransactionDetails => {
        
        setCurrentStep(2);
        setInitialRaiseChargebackData({
            merchantId: selectedTransactionDetails?.merchantCode,
            date: new Date().toDateString(),
            orderId: selectedTransactionDetails?.orderId,
            amount: selectedTransactionDetails?.amount,
            dueDate: moment()
                .add(4, 'days')
                .set({ hour: 18, minute: 30, second: 0 })
                .format('YYYY-MM-DD HH:mm:ss'),
            cbStatus: 'NEW',
            rrnNumber: selectedTransactionDetails?.rrn,
            remarks: 'remarks',
            cbLevel: 'L1',
            reportedDate: moment().startOf('day'),
            txnId: selectedTransactionDetails?.txnId,
            merchantName: selectedTransactionDetails?.merchantName,
            paymentType: selectedTransactionDetails?.paymentMode,
            transactionSubMode: selectedTransactionDetails?.transactionSubMode,
            type:selectedTransactionDetails?.dispute_type
        });
    };

    const handleRaiseChargebackFormSubmit = () => {
        setIsModalOpen(false);
        if (onRaiseSuccess && typeof onRaiseSuccess === 'function') {
            onRaiseSuccess();
        }
    };

    const handleModalClose = () => {
        setIsModalOpen(false);
        if (
            raiseChargeBackRequest &&
            typeof raiseChargeBackRequest === 'function'
        ) {
            raiseChargeBackRequest();
        }
    };

    return (
        <>
            <div className="raise-chargeback-button-container">
                <Button
                    buttonType="primary"
                    customClass="rounded-button"
                    text="Raise Dispute"
                    handleClick={handleRaiseChargeBackClick}
                />
            </div>
            <Modal
                modalIsOpen={isModalOpen}
                closeModal={handleModalClose}
                customWrapperClass={`content-modal ${
                    currentStep === 2 ? 'modal-xl' : ''
                }`}
            >
                <div className="modal-header">
                    <h2 className="modal-heading">Raise {initialRaiseChargebackData?.type ? capitalizeFirstLetter(initialRaiseChargebackData?.type) : "Dispute"}</h2>
                    <img
                        src={closeImgIcon}
                        alt="Close"
                        onClick={handleModalClose}
                    />
                </div>
                <div className="modal-body">
                    <ConditionalComponent isVisible={currentStep === 1}>
                        <FindTransactionForm
                            initialValues={{
                                searchParameter: 'TRANSACTION_ID',
                            }}
                            onSuccess={handleValidateFormSubmit}
                            onCancel={handleModalClose}
                        />
                    </ConditionalComponent>

                    <ConditionalComponent isVisible={currentStep === 2}>
                        <RaiseChargebackForm
                            initialValues={{
                                ...initialRaiseChargebackData,
                            }}
                            isTransactionPage
                            transactionData={transactionPageData}
                            onSuccess={handleRaiseChargebackFormSubmit}
                            onCancel={resetRaiseChargebackForm => {
                                setIsModalOpen(false);
                                resetRaiseChargebackForm();
                            }}
                        />
                    </ConditionalComponent>
                </div>
            </Modal>
        </>
    );
};

// PropType validation for Chargeback component
RaiseChargeBackComponent.propTypes = {
    actions: PropTypes.object,
    auth: PropTypes.object,
    chargebackData: PropTypes.object,
    isTransactionPage: PropTypes.bool,
    transactionPageData: PropTypes.object,
    onRaiseSuccess: PropTypes.func,
};

export default RaiseChargeBackComponent;
